<div class="card h-100 w-100 p-4 wow flipInX" data-wow-delay="delay">
  <div class="card-img pb-3 w-100">
    <i [class]="iconCss"></i>
  </div>
  <div class="card-body w-100">
      <h4>{{title}}</h4>
      <p class="display-7 pre-wrap" [innerHTML]="bodytext"></p>
  </div>
</div>
